import { AuthApp } from "components/auth-app";
import { CoverageContextProvider } from "pages/overview/extended-coverages/hooks";
import { CoverageContextProvider as ExtendedCoveragesContextProvider } from "pages/policy/extended-coverages/hooks";

const AuthAppWrapper = () => (
  <CoverageContextProvider>
    <ExtendedCoveragesContextProvider>
      <AuthApp />
    </ExtendedCoveragesContextProvider>
  </CoverageContextProvider>
);

export default AuthAppWrapper;
